<template>
  <div class="recharge-management">
    <el-row class="wenzi">充值管理</el-row>

    <!-- 余额信息卡片 -->
    <el-row class="balance-card">
      <el-col :span="8" class="balance-item balance-item-primary">
        <div class="balance-label">账户余额</div>
        <div class="balance-value">{{ accountInfo.balance }}<span class="unit">元</span></div>
      </el-col>
      <el-col :span="8" class="balance-item">
        <div class="balance-label">累计充值金额</div>
        <div class="balance-value">{{ accountInfo.totalRecharge }}<span class="unit">元</span></div>
      </el-col>
      <el-col :span="8" class="balance-item">
        <div class="balance-label">
          可退款金额
          <el-link type="primary" class="refund-link" @click="handleRefund">退款</el-link>
        </div>
        <div class="balance-value">{{ accountInfo.refundable }}<span class="unit">元</span></div>
      </el-col>
    </el-row>

    <!-- 充值表单 -->
    <el-row class="recharge-form-wrapper">
      <el-col :span="12">
        <el-form :model="rechargeForm" label-width="100px" class="recharge-form">
          <el-form-item label="充值金额:">
            <el-input 
              v-model="rechargeForm.amount" 
              placeholder="请输入充值金额"
              @input="handleAmountInput($event, 'rechargeForm')"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="支付方式:">
            <el-button 
              :type="rechargeForm.payMethod === 'alipay' ? 'primary' : 'default'"
              @click="handleAlipayClick"
            >支付宝支付</el-button>
            <el-button 
              :type="rechargeForm.payMethod === 'bank' ? 'primary' : 'default'"
              @click="handleBankClick"
            >对公打款</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12" class="bank-info-card">
        <div class="info-header">
          <span class="info-title">唯一有效对公收款账户（中国农业银行）</span>
        </div>
        <div class="info-content">
          <div class="info-item">
            <span class="info-label">账户名:</span>
            <span class="info-value">{{ bankInfo.invoiceTitle || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">开户行:</span>
            <span class="info-value">{{ bankInfo.invoiceBank || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">账号:</span>
            <span class="info-value">{{ bankInfo.invoiceBankNo || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">行号:</span>
            <span class="info-value">103653002068</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 充值记录表格 -->
    <el-table :data="rechargeRecords" border class="table-dci">
      <el-table-column label="付款ID" width="80">
        <template slot-scope="scope">
          {{ scope.row.userId || $store.getters.userId || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="订单号" width="180">
        <template slot-scope="scope">
          {{ scope.row.orderNo || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="充值方式" width="100">
        <template slot-scope="scope">
          {{ getSourceTypeLabel(scope.row.sourceType) }}
        </template>
      </el-table-column>
      <el-table-column label="充值提交时间" prop="createTime" width="160"></el-table-column>
      <el-table-column label="充值确认时间" prop="updateTime" width="160"></el-table-column>
      <el-table-column label="充值金额" prop="amount" width="100"></el-table-column>
      <el-table-column label="充值状态" min-width="150">
        <template slot-scope="scope">
          <div>
            <el-tag :type="getStateTagType(scope.row.state)">
              {{ getStateLabel(scope.row.state) }}
            </el-tag>
          </div>
          <div v-if="scope.row.rejectReason" class="reject-reason">
            驳回理由：{{ scope.row.rejectReason }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <!-- 操作按钮预留 -->
          <span>-</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-row>

    <!-- 对公打款弹窗 -->
    <el-dialog
      title="对公支付"
      :visible.sync="bankDialogVisible"
      width="500px"
    >
      <div class="bank-dialog-content">
        <!-- 充值金额 -->
        <div class="bank-dialog-row">
          <span class="row-label">充值金额：</span>
          <span class="row-value amount">{{ rechargeForm.amount || '0.00' }}</span>
          <span class="row-unit">元</span>
        </div>

        <!-- 提示信息 -->
        <div class="bank-dialog-tip warning">
          对公打款处理时间需要1-3个工作日，待确认到账后进入后续流程
        </div>

        <!-- 付款账户信息 -->
        <div class="bank-dialog-row">
          <span class="row-label">付款账户信息：</span>
          <el-select 
            v-model="bankPayForm.payAccountTitle" 
            placeholder="请选择付款账户" 
            style="width: 280px;"
            :disabled="lockPayAccount"
          >
            <el-option
              v-for="item in payAccountOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>

        <!-- 提示信息 -->
        <div class="bank-dialog-tip danger">
          付款账户信息必须和汇款单位完全一致，若上述下拉框无法选择您的汇款单位，请在账户中心→单位管理修改开票信息。
        </div>

        <!-- 上传打款凭证 -->
        <div class="bank-dialog-row">
          <span class="row-label">上传打款凭证：</span>
          <div class="voucher-upload-wrapper">
            <!-- 未上传时显示上传按钮 -->
            <el-upload
              v-if="!bankPayForm.voucherUrl"
              class="upload-voucher"
              action="#"
              accept="image/*"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleVoucherChange"
            >
              <div class="upload-btn" v-loading="uploadLoading">
                <i class="el-icon-plus"></i>
                <span>上传凭证</span>
              </div>
            </el-upload>
            <!-- 已上传时显示预览 -->
            <div v-else class="voucher-preview">
              <img :src="bankPayForm.voucherPreviewUrl" class="preview-image" @click="handlePreviewVoucher" />
              <div class="preview-actions">
                <el-button type="text" icon="el-icon-zoom-in" @click="handlePreviewVoucher">预览</el-button>
                <el-button type="text" icon="el-icon-delete" @click="handleRemoveVoucher">删除</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleBankSubmit">提交</el-button>
        <el-button @click="bankDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 退款弹窗 -->
    <el-dialog
      title="申请退款"
      :visible.sync="refundDialogVisible"
      width="400px"
      class="refund-dialog"
    >
      <el-form :model="refundForm" label-width="100px">
        <el-form-item label="可退款金额:">
          <span class="refund-available">{{ accountInfo.refundable }} 元</span>
        </el-form-item>
        <el-form-item label="退款金额:">
          <el-input 
            v-model="refundForm.amount" 
            placeholder="请输入退款金额"
            @input="handleAmountInput($event, 'refundForm')"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="账户名:">
          <el-input v-model="refundForm.accountName" placeholder="请输入账户名"></el-input>
        </el-form-item>
        <el-form-item label="账号:">
          <el-input v-model="refundForm.accountNo" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="开户行:">
          <el-input v-model="refundForm.bankName" placeholder="支付宝无须填写开户行信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleRefundSubmit" :loading="refundLoading">确认退款</el-button>
        <el-button @click="refundDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { payCharge, commonUpload, chargeUserApply, chargeGetList, balanceRefund, dciGetInfo } from '@/api/user.js'
import { openPaymentWindow } from '@/utils/index'

export default {
  name: 'RechargeManagement',
  data() {
    return {
      // 充值表单
      rechargeForm: {
        amount: '',           // 充值金额
        payMethod: 'alipay'   // 支付方式：alipay-支付宝, bank-对公打款
      },

      // 管理员银行信息
      bankInfo: {},


      // 充值记录列表 - 假数据，后续替换为接口数据
      rechargeRecords: [], // 充值记录列表

      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 来源类型选项 (sourceType)
      sourceTypeOptions: [
        { value: 0, label: '支付宝支付' },
        { value: 1, label: '对公打款' },
        { value: 2, label: '管理员添加' },
        { value: -1, label: '退款申请' }
      ],

      // 状态选项 (state)
      stateOptions: [
        { value: 0, label: '待审核' },
        { value: 1, label: '已同意' },
        { value: 2, label: '已作废' }
      ],

      // 对公打款弹窗
      bankDialogVisible: false,
      bankPayForm: {
        payAccountTitle: '',   // 付款账户ID
        voucherFile: null,  // 打款凭证原始文件
        voucherUrl: '',     // 打款凭证上传后的URL
        voucherPreviewUrl: '', // 本地预览URL
        payAccountBankNo: '', // 付款账户银行账号
      },
      uploadLoading: false, // 上传中状态

      // 退款弹窗
      refundDialogVisible: false,
      refundForm: {
        amount: '',       // 退款金额
        accountName: '',  // 账户名
        accountNo: '',    // 账号
        bankName: ''      // 开户行
      },
      refundLoading: false,

      // 付款账户选项
      payAccountOptions: [],

      // 是否锁定付款账户选择
      lockPayAccount: false
    }
  },
  computed: {
    // 从 store 获取账户余额信息
    accountInfo() {
      const userState = this.$store.state.user || {}
      return {
        balance: userState.balance || '0.00',
        totalRecharge: userState.totalCharge || '0.00',
        refundable: userState.balance || '0.00' // 可退款金额与余额相同
      }
    }
  },
  created() {
    this.getRechargeRecords()
    this.getAdminBankInfo()
    // 获取余额信息
    this.$store.dispatch('GetBalance')
  },
  methods: {
    // 获取管理员银行信息
    async getAdminBankInfo() {
      try {
        const res = await dciGetInfo({ userId: 1 })
        if (res.code === 200 && res.data) {
          // const { invoiceInfo } = res.data || {}
          this.bankInfo = res.data || {}
        }
      } catch (error) {
        console.error('获取管理员银行信息失败:', error)
      }
    },

    // 获取充值记录
    async getRechargeRecords() {
      try {
        const res = await chargeGetList({
          pageNum: this.currentPage,
          pageSize: this.pageSize
        })
        console.log('充值记录接口返回:', res)
        if (res.code === 200) {
          this.rechargeRecords = res.rows || res.data || []
          this.total = res.total || 0
        }
      } catch (error) {
        console.error('获取充值记录失败:', error)
      }
    },

    // 获取来源类型标签
    getSourceTypeLabel(value) {
      const item = this.sourceTypeOptions.find(opt => opt.value === value)
      return item ? item.label : value
    },

    // 获取状态标签
    getStateLabel(value) {
      const item = this.stateOptions.find(opt => opt.value === value)
      return item ? item.label : value
    },

    // 获取状态标签类型
    getStateTagType(state) {
      const typeMap = {
        0: 'warning',  // 待审核
        1: 'success',  // 已同意
        2: 'info'      // 已作废
      }
      return typeMap[state] || 'info'
    },

    // 打开退款弹窗
    handleRefund() {
      this.refundForm = {
        amount: '',
        accountName: '',
        accountNo: '',
        bankName: ''
      }
      this.refundDialogVisible = true
    },

    // 提交退款申请
    async handleRefundSubmit() {
      if (!this.refundForm.amount) {
        this.$message.warning('请输入退款金额')
        return
      }
      if (!this.refundForm.accountName) {
        this.$message.warning('请输入账户名')
        return
      }
      if (!this.refundForm.accountNo) {
        this.$message.warning('请输入账号')
        return
      }
      const amount = parseFloat(this.refundForm.amount)
      if (isNaN(amount) || amount <= 0) {
        this.$message.warning('请输入有效的退款金额')
        return
      }
      const refundable = parseFloat(this.accountInfo.refundable)
      if (amount > refundable) {
        this.$message.warning('退款金额不能超过可退款金额')
        return
      }

      // 拼接 paymentAccount：账户名 账号 开户行（用空格间隔）
      const paymentAccount = [
        this.refundForm.accountName,
        this.refundForm.accountNo,
        this.refundForm.bankName
      ].filter(Boolean).join(' ')

      this.refundLoading = true
      try {
        const userId = this.$store.getters.userId
        const res = await balanceRefund({ amount: amount, paymentAccount: paymentAccount, userId: userId })
        if (res.code === 200) {
          this.$message.success('退款申请提交成功')
          this.refundDialogVisible = false
          this.refundForm = { amount: '', accountName: '', accountNo: '', bankName: '' }
          this.getRechargeRecords() // 刷新列表
          this.$store.dispatch('GetBalance') // 刷新余额
        } else {
          this.$message.error(res.msg || '退款申请失败')
        }
      } catch (error) {
        this.$message.error('退款请求失败')
      } finally {
        this.refundLoading = false
      }
    },

    // 金额输入限制：只允许数字和小数点，最多两位小数
    handleAmountInput(value, formName) {
      // 移除非数字和小数点
      let val = value.replace(/[^\d.]/g, '')
      // 只保留第一个小数点
      const dotIndex = val.indexOf('.')
      if (dotIndex !== -1) {
        val = val.slice(0, dotIndex + 1) + val.slice(dotIndex + 1).replace(/\./g, '')
      }
      // 限制小数点后最多两位
      if (dotIndex !== -1 && val.length > dotIndex + 3) {
        val = val.slice(0, dotIndex + 3)
      }
      // 更新对应的表单
      if (formName === 'rechargeForm') {
        this.rechargeForm.amount = val
      } else if (formName === 'refundForm') {
        this.refundForm.amount = val
      }
    },

    // 取消充值
    handleCancel(row) {
      this.$confirm('确定要取消该充值订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // TODO: 调用取消接口
        this.$message.success('取消成功')
      }).catch(() => {})
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getRechargeRecords()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getRechargeRecords()
    },

    // 点击支付宝支付按钮
    async handleAlipayClick() {
      if (!this.rechargeForm.amount) {
        this.$message.warning('请输入充值金额')
        return
      }
      this.rechargeForm.payMethod = 'alipay'
      try {
        const res = await payCharge({ amount: this.rechargeForm.amount })
        if (res.code === 200 && res.msg) {
          openPaymentWindow(res.msg)
          this.$message.success('已打开支付页面，请完成支付')
          this.rechargeForm.amount = ''
          this.getRechargeRecords()
          // 刷新余额
          this.$store.dispatch('GetBalance')
        } else {
          this.$message.error(res.msg || '获取支付地址失败')
        }
      } catch (error) {
        this.$message.error('支付请求失败')
      }
    },

    // 点击对公打款按钮
    handleBankClick() {
      if (!this.rechargeForm.amount) {
        this.$message.warning('请输入充值金额')
        return
      }
      this.rechargeForm.payMethod = 'bank'

      // 从状态管理获取当前用户的发票信息
      const realInfo = this.$store.state.realInformation || {}
      const invoiceTitle = realInfo.invoiceTitle || ''
      const invoiceBankNo = realInfo.invoiceBankNo || ''
      
      this.payAccountOptions = invoiceTitle ? [{ value: '1', label: invoiceTitle }] : []
      this.lockPayAccount = !!invoiceTitle

      // 重置表单，并默认选中
      this.handleRemoveVoucher() // 清理旧的凭证
      this.bankPayForm = {
        payAccountTitle: invoiceTitle ? '1' : '',
        voucherFile: null,
        voucherUrl: '',
        voucherPreviewUrl: '',
        payAccountBankNo: invoiceBankNo
      }
      this.bankDialogVisible = true
    },

    // 打款凭证上传变化
    async handleVoucherChange(file) {
      if (!file || !file.raw) return
      
      // 校验文件类型
      const isImage = file.raw.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('请上传图片格式的文件')
        return
      }
      
      // 校验文件大小（限制 5MB）
      const isLt5M = file.raw.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return
      }
      
      this.uploadLoading = true
      try {
        const formData = new FormData()
        formData.append('file', file.raw)
        const res = await commonUpload(formData)
        if (res.code === 200) {
          this.bankPayForm.voucherFile = file.raw
          this.bankPayForm.voucherUrl = res.url
          this.bankPayForm.voucherPreviewUrl = URL.createObjectURL(file.raw)
          this.$message.success('上传成功')
        } else {
          this.$message.error(res.msg || '上传失败')
        }
      } catch (error) {
        this.$message.error('上传失败')
      } finally {
        this.uploadLoading = false
      }
    },

    // 预览凭证
    handlePreviewVoucher() {
      if (this.bankPayForm.voucherPreviewUrl) {
        window.open(this.bankPayForm.voucherPreviewUrl, '_blank')
      }
    },

    // 删除凭证
    handleRemoveVoucher() {
      this.bankPayForm.voucherFile = null
      this.bankPayForm.voucherUrl = ''
      if (this.bankPayForm.voucherPreviewUrl) {
        URL.revokeObjectURL(this.bankPayForm.voucherPreviewUrl)
        this.bankPayForm.voucherPreviewUrl = ''
      }
    },

    // 对公打款提交
    async handleBankSubmit() {
      if (!this.bankPayForm.payAccountTitle) {
        this.$message.warning('请选择付款账户信息')
        return
      }
      if (!this.bankPayForm.voucherUrl) {
        this.$message.warning('请上传打款凭证')
        return
      }
      
      try {
        const userId = this.$store.getters.userId
        const res = await chargeUserApply({
          amount: this.rechargeForm.amount,
          attachment: this.bankPayForm.voucherUrl,
          paymentAccount: this.bankPayForm.payAccountBankNo,
          userId: userId
        })
        if (res.code === 200) {
          this.$message.success('提交成功，请等待审核')
          this.bankDialogVisible = false
          this.rechargeForm.amount = ''
          this.handleRemoveVoucher() // 清理凭证
          this.getRechargeRecords()
          // 刷新余额
          this.$store.dispatch('GetBalance')
        } else {
          this.$message.error(res.msg || '提交失败')
        }
      } catch (error) {
        this.$message.error('提交失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.recharge-management {
  padding-left: 80px;
}

.reject-reason {
  margin-top: 5px;
  font-size: 12px;
  color: #F56C6C;
}

.wenzi {
  height: 80px;
  text-align: left;
  line-height: 80px;
  letter-spacing: normal;
  color: #333333;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  white-space: nowrap;
}

// 余额卡片
.balance-card {
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
  border-radius: 4px;
  padding: 20px 0;
  margin-bottom: 20px;
  margin-right: 40px;

  .balance-item {
    text-align: center;
    color: #fff;
    border-right: 1px solid rgba(255, 255, 255, 0.3);

    &:last-child {
      border-right: none;
    }

    .balance-label {
      font-size: 14px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .balance-value {
      font-size: 28px;
      font-weight: bold;

      .unit {
        font-size: 14px;
        margin-left: 5px;
      }
    }

    .refund-link {
      color: #fff;
      margin-left: 10px;
      text-decoration: underline;
    }
  }
}

// 充值表单
.recharge-form-wrapper {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;
  margin-right: 40px;
}

.recharge-form {
  .el-input {
    width: 250px;
  }
}

// 银行信息卡片
.bank-info-card {
  padding-left: 30px;
  border-left: 1px solid #ebeef5;

  .info-header {
    margin-bottom: 12px;
  }

  .info-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  .info-content {
    .info-item {
      display: flex;
      align-items: flex-start;
      line-height: 28px;
      font-size: 14px;
    }

    .info-label {
      flex-shrink: 0;
      width: 60px;
      color: #909399;
    }

    .info-value {
      flex: 1;
      color: #303133;
      word-break: break-all;
    }
  }
}

// 表格
.table-dci {
  margin-right: 40px;
  
  ::v-deep th,
  ::v-deep td {
    text-align: center !important;
  }
}

// 分页
.pagination {
  text-align: end;
  margin-top: 20px;
  margin-right: 40px;
}

// 对公打款弹窗
.bank-dialog-content {
  .bank-dialog-row {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .row-label {
      width: 100px;
      text-align: right;
      color: #666;
      font-size: 14px;
    }

    .row-value {
      font-size: 14px;
      color: #333;

      &.amount {
        font-size: 24px;
        font-weight: bold;
        color: #409EFF;
      }
    }

    .row-unit {
      font-size: 14px;
      color: #666;
      margin-left: 5px;
    }
  }

  .bank-dialog-tip {
    font-size: 12px;
    line-height: 1.6;
    padding: 10px 15px;
    border-radius: 4px;
    margin-bottom: 20px;
    margin-left: 100px;

    &.warning {
      background: #fdf6ec;
      color: #e6a23c;
    }

    &.danger {
      background: #fef0f0;
      color: #f56c6c;
    }
  }

  .voucher-upload-wrapper {
    display: inline-block;
  }

  .upload-voucher {
    .upload-btn {
      width: 120px;
      height: 120px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: border-color 0.3s;
      background-color: #fafafa;

      &:hover {
        border-color: #409EFF;
      }

      i {
        font-size: 28px;
        color: #8c939d;
        margin-bottom: 8px;
      }

      span {
        font-size: 12px;
        color: #8c939d;
      }
    }
  }

  .voucher-preview {
    display: flex;
    flex-direction: column;
    align-items: center;

    .preview-image {
      width: 120px;
      height: 120px;
      object-fit: cover;
      border-radius: 6px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        border-color: #409EFF;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
      }
    }

    .preview-actions {
      margin-top: 8px;
      
      .el-button {
        padding: 4px 8px;
        font-size: 12px;
      }
    }
  }
}

// 退款弹窗
.refund-dialog {
  .refund-available {
    font-size: 18px;
    font-weight: bold;
    color: #409EFF;
  }
  
  .dialog-footer {
    text-align: center;
  }
}
</style>

